import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
export default class User extends GenexLMSModel {
    static entity = 'boardUser'

    static primaryKey = ['board_id', 'user_id']


    static fields() {
        return {
            board_id: this.attr(null),
            user_id: this.attr(null)
        }
    }


}